var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-blue"},[_vm._t("custom"),_c('div',{staticClass:"container-blue__top"},[_c('div',{staticClass:"container-blue__top__left"},[_vm._t("top__left")],2),_c('div',{staticClass:"container-blue__top__right"},[_vm._t("top__right")],2)]),_c('div',{staticClass:"container-blue__bottom"},[_vm._t("bottom")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }